var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveinventory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.338,
    height: 40,
    viewBox: "0 0 45.338 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16786 -15623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16786 15623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.878,34.045H9.592a5.031,5.031,0,0,1-5.026-5.026V-.929a5.1,5.1,0,0,1,.049-.7A5.033,5.033,0,0,0,.289,3.348V33.3a5.031,5.031,0,0,0,5.026,5.026H40.6A5.032,5.032,0,0,0,45.578,34a5.049,5.049,0,0,1-.7.05Zm0,0",
    transform: "translate(-0.264 1.654)",
    fill: "#cedbfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.338,3.108V33.056a5.031,5.031,0,0,1-5.026,5.026H5.026A5.031,5.031,0,0,1,0,33.056V3.108A5.031,5.031,0,0,1,5.026-1.918H40.312A5.031,5.031,0,0,1,45.338,3.108Zm-1.5,29.949V10.068H1.5V33.056a3.532,3.532,0,0,0,3.529,3.529H40.312A3.532,3.532,0,0,0,43.841,33.056Zm0-24.485V3.108A3.532,3.532,0,0,0,40.312-.421H5.026A3.532,3.532,0,0,0,1.5,3.108V8.571Zm0,0",
    transform: "translate(0 1.918)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.142 3.643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.22,45.944h.008a2.369,2.369,0,0,0,2.368-2.361v-.007a2.371,2.371,0,0,0-2.362-2.368h-.006a2.369,2.369,0,0,0-.008,4.737Zm.008-3.24h0a.872.872,0,0,1,0,1.743h0a.872.872,0,1,1,0-1.743Zm0,0",
    transform: "translate(-192.303 -41.161)",
    fill: "#f0b33f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.146,40.945h-.008a2.368,2.368,0,1,0-.007,4.737h.007a2.371,2.371,0,0,0,2.368-2.361v-.007a2.369,2.369,0,0,0-2.361-2.369Zm-.01,3.24a.871.871,0,0,1,0-1.743h0a.871.871,0,1,1-.005,1.743Zm0,0",
    transform: "translate(-114.492 -40.922)",
    fill: "#f0b33f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.11,40.672A2.369,2.369,0,0,0,39.1,45.41H39.1a2.369,2.369,0,1,0,.008-4.738ZM39.1,43.913h0a.872.872,0,0,1,0-1.744h0a.872.872,0,1,1,0,1.744Zm0,0",
    transform: "translate(-36.734 -40.672)",
    fill: "#f0b33f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.858 13.083)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.581,126.033l-2.354-4.708A.571.571,0,0,0,45.7,121H33.93a.574.574,0,0,0-.527.325l-2.354,4.708a.585.585,0,0,0,.083.65l8.239,9.455a.588.588,0,0,0,.887,0l8.239-9.455A.585.585,0,0,0,48.581,126.033Zm-3.833-3.856-1.5,3-2.254-3Zm-2.579,3.531H37.461l2.354-3.139Zm-3.531-3.531-2.254,3-1.5-3Zm-4.708.727,1.4,2.8h-2.8Zm-1.061,3.981H35.9l2.9,6.8Zm6.946,6.19-2.64-6.19h5.28Zm1.019.612,2.9-6.8h3.026Zm3.465-7.979,1.4-2.8,1.4,2.8Z",
    transform: "translate(-30.987 -121)",
    fill: "#f0b33f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.589,0A.589.589,0,0,0,241,.589V1.8a.589.589,0,1,0,1.177,0V.589A.589.589,0,0,0,241.589,0Z",
    transform: "translate(-241)",
    fill: "#f0b33f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.494 1.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.377,41.545l-.832-.832a.589.589,0,0,0-.832.832l.832.832a.589.589,0,1,0,.832-.832Z",
    transform: "translate(-145.54 -40.541)",
    fill: "#f0b33f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.153 1.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.082,40.713a.588.588,0,0,0-.832,0l-.832.832a.589.589,0,0,0,.832.832l.832-.832A.589.589,0,0,0,317.082,40.713Z",
    transform: "translate(-315.245 -40.54)",
    fill: "#f0b33f"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveinventory);
export default __webpack_public_path__ + "static/media/liveinventory.ce76f9cd3f37834c3bd07bc6932443f5.svg";
export { ForwardRef as ReactComponent };